import { render } from "./TbActions.vue?vue&type=template&id=89ffee30"
import script from "./TbActions.vue?vue&type=script&lang=js"
export * from "./TbActions.vue?vue&type=script&lang=js"
script.render = render

export default script